/* ── INVASIVE THOT CUSTOM ─────────────────────────────────────
   The Shopify Forms embed renders in an OPEN shadow root, so
   its own settings can't do everything we want — this script
   injects a stylesheet inside it:
     • consent fine print in black (widget text color is green)
     • the site's mono font instead of the widget's default
   Loaded from layout/theme.liquid next to the notify modal.
   ───────────────────────────────────────────────────────────── */

(() => {
  const CSS = `
    * {
      font-family: 'IBM Plex Mono', 'Courier New', monospace !important;
    }
    [class*='_formDisclaimer'],
    [class*='_formDisclaimer'] * {
      color: #000 !important;
    }
  `;

  const inject = (el) => {
    if (!el.shadowRoot || el.shadowRoot.querySelector('style[data-it-tweaks]')) return;
    const style = document.createElement('style');
    style.setAttribute('data-it-tweaks', 'true');
    style.textContent = CSS;
    el.shadowRoot.appendChild(style);
  };

  const scan = () => document.querySelectorAll('shopify-forms-embed').forEach(inject);

  scan();
  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
  /* the embed mounts its shadow content async; re-check briefly */
  let tries = 0;
  const timer = setInterval(() => {
    scan();
    if ((tries += 1) > 20) clearInterval(timer);
  }, 500);
})();
